<template>
    
    <h1 v-if="!pokemon">
        Espere por favor...
    </h1>

    <div v-else>
        <h1>¿Quien es este pokemon?</h1>
        
        <PokemonPicture
          :pokemonId="pokemon.id"
          :showPokemon="showPokemon"
        />
        
        <PokemonOptions 
        :pokemons="pokemonArr"
        @selection="checkAnswer
        "/>

        
        <div>
            <h2>
                {{ message }}
            </h2>
    
            <button 
            v-if="message"
            @click="newGame"
            class="btn effect01">
                <span>Nuevo Juego</span>
            </button>
        </div>


    </div>


</template>

<script>

import PokemonOptions from '@/components/PokemonOptions.vue';    
import PokemonPicture from '@/components/PokemonPicture.vue';

import getPokemonOptions from '@/helpers/getPokemonOptions'



export default {
    components: {
    PokemonPicture,
    PokemonOptions
},
    data() {
        return {
            pokemonArr: [],
            pokemon: null,
            showPokemon: false,
            showAnswer: false,
            message: ''
        }
    },
    methods: {
        async mixPokemonArray() {
            this.pokemonArr = await getPokemonOptions()

            const rndInt = Math.floor(Math.random() * 4)
            this.pokemon = this.pokemonArr[rndInt]
        },
        checkAnswer(selectedId) {
            this.showPokemon = true
            this.showAnswer = true

            if( selectedId === this.pokemon.id ) {
                this.message = `Correcto, ${ this.pokemon.name }`
            } else {
                this.message = `Oops, era ${ this.pokemon.name }`
            }
        },
        newGame() {
            this.showPokemon = false
            this.showAnswer  = false
            this.pokemonArr  = []
            this.pokemon     = null
            this.message     = ''
            this.mixPokemonArray()
        }
    },
    mounted() {
        this.mixPokemonArray()
    }
}
</script>
